import React from "react";
// import Container from 'react-bootstrap/Container';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import './footer.scss';

const year = new Date().getFullYear()

class Footer extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          
        }
      }
  render(){

    return (
      <div className="footer-main">
          
        <div className="social-media-box">
            <div className={"wrapper"} onClick={(e)=>{

            }}>
              <img className={"wrapper-img"} src={"/assets/fb.svg"} alt="Facebook" width="50px" />
            </div>
            <div className={"wrapper"} onClick={(e)=>{
              
            }}>
              <img className={"wrapper-img"} src={"/assets/ig.svg"} alt="Instagram" width="50px" />
            </div>
        </div>

        <div className="legal-link">
            <div className={"legal-link-a"}>{"Copyright @ "+year+"  All rights reserved"}</div>
        </div>

        <div className="legal-link">
            <div className="legal-link-a" onClick={(e)=>{
                this.props.setval({currentPage:"legalpage"})
            }}>{"Legal, Privacy and Terms of Use"}</div>
        </div>

        <div className="legal-link">
             <div className="legal-link-a" onClick={(e)=>{
                window.open("mailto:ytmagasin@gmail.com?subject=YT Magasin - Enquiry from Website&body=Dear YT Magasin,\n\r")
            }}>{"Contact us"}</div>
        </div>


      </div>
    );


  }
}

export default Footer;
